<template>
  <div class="join_us_box">
    <div class="join_wrap">
      <h2>JOIN US</h2>
      <div class="line_bor"></div>
      <div class="top_txt_box">
        <p class="top_txt">
          ShanghaiEye, SMG’s new media platform, creates high-quality videos
          that tell the stories of Shanghai and China.
        </p>
        <p class="top_txt">
          You can find ShanghaiEye on our mobile and online site
          (www.ShanghaiEye.cn), Facebook, Twitter, Instagram, Weibo, and Wechat.
        </p>
        <p class="top_txt">
          If you have passion for new media production and content production,
          our team is waiting for you to join us.
        </p>
        <h3>Copy Editor</h3>
        <p class="top_txt">
          ShanghaiEye is looking to hire a native English speaker with media
          experiences.
        </p>
        <h4>What you will be doing:</h4>
        <ul>
          <li>Polish texts for assigned reports from the New Media Team.</li>
          <li>
            Write reports, scripts, columns, and other assigned writing pieces
            for the New Media Team.
          </li>
          <li>
            Polish reports and texts for distribution and contribution purposes.
          </li>
          <li>
            Help journalists and editors develop stories, run brainstorming
            sessions, plan activities and events, etc.
          </li>
          <li>Host programs for the New Media Team.</li>
          <li>
            Understand that due to the characteristics of New Media, quick
            response to breaking news may be needed on weekends and holidays.
          </li>
          <li>
            Provide assessment and training to journalists and editors in
            writing and reporting skills.
          </li>
          <li>
            Polish assigned writing pieces for communication or other corporate
            use.
          </li>
          <li>Fill in for other copy editors upon request of management.</li>
        </ul>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Footer from "@/components/common/layout/Footer.vue";
export default {
  data() {
    return {};
  },
  components: {
    Footer,
  },
  mounted() {
    document.title = "Join Us | ShanghaiEye";
  },
};
</script>

<style lang="less" scoped>
.join_us_box {
  .join_wrap {
    width: 70%;
    margin: 0 auto;
    h2 {
      line-height: 1.2;
      font-family: FranklinGothic-Demi, sans-serif !important;
      letter-spacing: 0.05em;
      font-size: 40px;
      font-weight: bold;
      text-align: center;
      padding-top: 40px;
      padding-bottom: 20px;
      // border-bottom: 3px solid #ccc;
      margin-bottom: 0;
    }
    .line_bor {
      height: 4px;
      border-top: 1px solid #ccc;
      border-bottom: 1px solid #ccc;
    }
    .top_txt_box {
      padding: 26px 20px;
    }
    .top_txt {
      font-size: 16px;
      font-family: "Open Sans";
      word-break: break-word;
      margin-bottom: 0 !important;
      letter-spacing: 0.05em;
      line-height: 30px;
    }
    h3 {
      font-size: 22px;
      line-height: 1.5;
      font-weight: bold;
      margin-bottom: 0;
      padding-top: 20px;
    }
    h4 {
      font-size: 18px;
      font-weight: bold;
      line-height: 1.5;
      margin-bottom: 0;
    }
    ul {
      padding-left: 25px;
      li {
        font-size: 16px;
        font-family: "Open Sans";
        word-break: break-word;
        margin-bottom: 0 !important;
        letter-spacing: 0.05em;
        line-height: 30px;
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .join_us_box {
    .join_wrap {
      width: 100%;
    }
  }
}
</style>
